/** Org sender / contact block fields shared by proposals, org forms, and future doc blocks. */
export type DocumentContactFields = {
  org_name: string;
  person_name: string;
  address: string;
  phone: string;
  email: string;
};

export function emptyDocumentContactFields(): DocumentContactFields {
  return {
    org_name: "",
    person_name: "",
    address: "",
    phone: "",
    email: "",
  };
}

export function documentContactFieldsFromPartial(
  partial:
    | Partial<Record<keyof DocumentContactFields, string | null | undefined>>
    | null
    | undefined,
): DocumentContactFields {
  return {
    org_name: partial?.org_name ?? "",
    person_name: partial?.person_name ?? "",
    address: partial?.address ?? "",
    phone: partial?.phone ?? "",
    email: partial?.email ?? "",
  };
}
